import { del, get } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON, operationToPaginatedJSON, paginateAPIOptions, } from "../util/amplify-utils";
function objectEventParamsToPath(params) {
    if (params.assetID !== undefined) {
        return `/events/${params.category}/asset/${params.assetID}`;
    }
    else if (params.deviceID !== undefined) {
        return `/events/${params.category}/device/${params.deviceID}`;
    }
    else if (params.siteID !== undefined) {
        return `/events/${params.category}/site/${params.siteID}`;
    }
    else if (params.geofenceID !== undefined) {
        return `/events/${params.category}/geofence/${params.geofenceID}`;
    }
    else {
        return `/events/${params.category}`;
    }
}
function getEssentialEventsParamsToPath(params) {
    if ("assetID" in params) {
        return `/essentialevents/asset/${params.assetID}`;
    }
    else {
        return `/essentialevents/device/${params.deviceID}`;
    }
}
function filterEventTimeParamsToQuery(params) {
    const query = {};
    if (params.since !== undefined) {
        query["since"] = params.since.toISOString();
    }
    if (params.until !== undefined) {
        query["until"] = params.until.toISOString();
    }
    return query;
}
export default class VelavuAPIEvents {
    //This method returns all events associated with an asset or device.
    getAllEvents(params, pagination) {
        //Resolve the path
        const path = objectEventParamsToPath(params);
        //Resolve the query parameters
        const query = filterEventTimeParamsToQuery(params);
        return normalizePromiseError(operationToPaginatedJSON(get({
            apiName: API_NAME_VELAVU,
            path: path,
            options: paginateAPIOptions(pagination, {
                queryParams: query,
            }),
        })));
    }
    //This method queries several "essential" event categories and returns the combined result. 
    getEssentialEvents(params) {
        //Resolve the path
        const path = getEssentialEventsParamsToPath(params);
        //Resolve the query parameters
        const query = filterEventTimeParamsToQuery(params);
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: path,
            options: {
                queryParams: query,
            },
        })));
    }
    //This method deletes all of a device's or asset's events.
    deleteAllEvents(params) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: objectEventParamsToPath(params),
        }).response);
    }
}
//# sourceMappingURL=velavu-api-events.js.map